var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwissFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 31",
    d: "M0 0h24v24H0z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 1",
    d: "M9.647 20v-5.647H4V9.647h5.647V4h4.705v5.647H20v4.705h-5.647V20z",
    fill: "#fff"
  }))));
}
export default SvgSwissFlag;